import { render, staticRenderFns } from "./roleArea.vue?vue&type=template&id=f67301b0&"
import script from "./roleArea.vue?vue&type=script&lang=js&"
export * from "./roleArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports